import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiSyncExternalStoreWarehousesMethod,
    type OpenApiSyncExternalStoreWarehousesRequest,
    type OpenApiSyncExternalStoreWarehousesResponseSuccess,
    OpenApiSyncExternalStoreWarehousesUrl,
} from '#shared/api/schema';

const externalStoreApi = createApi({
    name: 'entities/integration/api/externalStoreApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            syncExternalStoreWarehouses: builder.mutation<
                OpenApiSyncExternalStoreWarehousesResponseSuccess,
                OpenApiSyncExternalStoreWarehousesRequest
            >({
                query: () => {
                    return {
                        method: OpenApiSyncExternalStoreWarehousesMethod,
                        url: OpenApiSyncExternalStoreWarehousesUrl,
                    };
                },
            }),
        };
    },
});

export const syncExternalStoreWarehouses = externalStoreApi.syncExternalStoreWarehousesMutation;
